module.exports = function() {
  return new Worker(__webpack_public_path__ + "bb8269b8f34ed95cf7a5.worker.js");
};